export default theme => ({

  root: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    overflowX: 'hidden',
    overflowY: 'auto',
    marginTop: theme.spacing.unit * 7,
    marginBottom: theme.spacing.unit
  },

  noHeader: {
    marginTop: 0
  },

  '@media (min-width: 600px)': {

    root: {
      marginTop: theme.spacing.unit * 8
    },

    noHeader: {
      marginTop: 0
    }

  }

});





// WEBPACK FOOTER //
// ./src/styles/components/CodeInfo.js